<div class="ui-g-12 no-padding">
	<common-list
		[context]="commonListContext">
	</common-list>
</div>